import '../Surveys.less'

import { ButtonIcon, Flex } from 'front-end/src/components'
import IconSettings from 'front-end/src/components/common/icon/IconSettings'
import React, { useEffect, useState } from 'react'
import { Route, Switch } from 'react-router-dom'

import { t, Trans } from '@lingui/macro'

import Spinner from '../../../components/common/loader/Loader'
import Message, {
  MessageTypes
} from '../../../components/common/message/Message'
import PageHeader from '../../../components/common/page/header/PageHeader'
import { TabsStatic } from '../../../components/common/tabs/TabsLegacy'
import SurveyStatus from '../SurveyStatus'
import { ISurvey, ISurveyQuestion } from '../types'
import { useManageSurveyQuery } from './ManageSurvey.codegen'
import { ManageSurveyContext } from './ManageSurveyContext'
import { SurveysResults } from './results/SurveyResults'
import { SurveySend } from './send/SurveySend'
import SurveySummary from './summary/SurveySummary'
import { SurveysCreate } from './survey/SurveyCreate'
import { SurveySettingsDrawer } from './SurveySettingsDrawer'

export const ManageSurveyPage = ({ match }) => {
  const [questions, setQuestions] = useState<ISurveyQuestion[]>([])
  const [drawerVisible, setDrawerVisible] = useState(false)

  const { data, refetch } = useManageSurveyQuery({
    variables: {
      id: +match.params.surveyId
    }
  })

  const survey = data?.admin?.survey

  useEffect(() => {
    if (survey) {
      setQuestions(survey?.questions as ISurveyQuestion[])
    }
  }, [survey])

  const tabList = [
    {
      caption: t`Summary`,
      href: match.url
    },
    {
      caption: t`Survey`,
      href: `${match.url}/create`
    },
    {
      caption: t`Access`,
      href: `${match.url}/send`
    },
    {
      caption: t`Results`,
      href: `${match.url}/results`
    }
  ]

  if (!data) {
    return <Spinner />
  }

  if (!survey) {
    return (
      <Message type={MessageTypes.ERROR}>
        <Trans>Survey doesn't exist</Trans>
      </Message>
    )
  }

  return (
    <ManageSurveyContext.Provider
      value={{
        survey: survey as any as ISurvey,
        refetchSurvey: refetch,
        questions,
        setQuestions
      }}
    >
      <div className="Survey Page">
        <PageHeader
          className="PageHeader"
          title={
            <>
              {survey.title}
              <Flex ml="12px">
                <SurveyStatus
                  isPublished={!!survey.published_at}
                  isCompleted={!!survey.completed_at}
                />
              </Flex>
            </>
          }
          titleRawText={survey.title}
          titleFollowers={
            <ButtonIcon
              circular
              aria-label={t`Settings`}
              hint={t`Settings`}
              icon={<IconSettings />}
              onClick={() => setDrawerVisible(true)}
            />
          }
        />
        <TabsStatic tabList={tabList}>
          <Switch>
            <Route
              path={`${match.url}/create`}
              render={() => <SurveysCreate />}
            />
            <Route path={`${match.url}/send`} render={() => <SurveySend />} />
            <Route
              path={`${match.url}/results`}
              render={() => <SurveysResults />}
            />
            <Route render={() => <SurveySummary />} />
          </Switch>
        </TabsStatic>
      </div>
      <SurveySettingsDrawer
        show={drawerVisible}
        onHide={() => {
          setDrawerVisible(false)
        }}
      />
    </ManageSurveyContext.Provider>
  )
}
